import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import HelpSupportListPage from "../../components/HelpAndSupport/HelpSupportListPage";


const HelpAndSupportPage = () => {
    return (
        <>
            <MasterLayout>
                <Breadcrumb title="Help And Support" />
                <HelpSupportListPage/>
            </MasterLayout>

        </>
    );
};

export default HelpAndSupportPage; 
